import { ArrowTopRightOnSquareIcon, CheckCircleIcon, CloudArrowDownIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import Pagination from "../components/pagination";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BarFilters, BarFiltersIcon, BarFiltersLeft, DivProduct, Search } from "../home-table/styled";
import FiltersOrder from "../components/filters-order";
import { sizeFiles } from "../../../../utils/convert";
import TableDownload from "../components/table-download";
import { ContaineControlSizeNew, ContainerNew } from "../home-table/styled-new";
import Loading from "../../../../components/Loading";
import PageLock from "../components/page-lock";
import PageError from "../components/page-error";
import PageForbidden from "../components/page-forbidden";
import LoginOrder from "../components/login";
import LanguageBar from "../../../products/components/bar-language";
import {
    getCheckoutBadgeClass,
    getCheckoutBadgeStyle,
    getCheckoutButtonClass,
    getCheckoutButtonStyle,
} from "../../../thema/components/ColorSwatchPicker";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function HomeLogin() {
    const params = useParams();
    const dispatch = useDispatch();
    const [page, setpage] = useState(1)
    const [statusLogin, setStatusLogin] = useState(false)

    const [search, setsearch] = useState("")
    const products = useSelector((state) => state.reducerYourMedias);
    const orders = useSelector((state) => state.reducerLoginOrder);
    const [config, setConfig] = useState("")
    const [filterProducts, setfilterProducts] = useState([])

    const checkoutColor = config?.checkout_color || "gray";
    const getColorButton = () => getCheckoutButtonClass(checkoutColor);
    const getColorButtonStyle = () => getCheckoutButtonStyle(checkoutColor);
    const getColorType = () => getCheckoutBadgeClass(checkoutColor);
    const getColorTypeStyle = () => getCheckoutBadgeStyle(checkoutColor);
    const getColorMedia = () => getCheckoutBadgeClass(checkoutColor);
    const getColorMediaStyle = () => getCheckoutBadgeStyle(checkoutColor);

    const getplatform = (code) => {
        switch (code) {
            case "1" || 1:
                return "nuvemshop"
            case "4" || 4:
                return "shopify"
            case "2" || 2:
                return "yampi"
            default:
                return "nuvemshop"
        }
    }


    // Após login bem-sucedido, buscar dados dos produtos
    useEffect(() => {
        // console.log("useEffect orders/statusLogin:", { orders: orders.data, statusLogin });

        // if (orders?.data && statusLogin && !orders.loading && !orders.error) {
        //     console.log("Fazendo GET_ORDER_DATA após login bem-sucedido", orders.data);
        //     dispatch({ type: "GET_ORDER_DATA", payload: { user_id: orders?.data?.user_token, order_id: orders?.data?.order_id, store_id: params.userId, }, });

        // }
        console.log("useEffect orders/statusLogin:", { orders: orders.data, statusLogin });

        if (orders?.data && statusLogin && !orders.loading && !orders.error) {
            console.log("Fazendo GET_ORDER_DATA após login bem-sucedido", orders.data);
            window.location.href = `https://meuarquivodigital.com/suamidia/${orders?.data?.user_token}/${params.userId}/${orders?.data?.order_id}`;

        }
    }, [orders, statusLogin, dispatch]);

    useEffect(() => {
        console.log("products", products)
        try {
            setfilterProducts(getDownloads())
            setConfig(products?.data?.template[0])
        } catch (error) {
            console.log("error setting products", error)
        }
    }, [products])

    useEffect(() => {
        console.log("orders", orders)
    }, [orders])

    const getDownloads = () => {
        let data = []
        if (products.data?.data) {
            products.data.data.forEach(element => {
                if (Array.isArray(element)) {
                    element.forEach(item => {
                        data.push(item)
                    });
                } else {
                    data.push(element)
                }
            });
        }
        return data
    }

    const download = (item) => {
        // Usar dados do login para download
        const orderData = orders.data;
        if (item.type == "url") {
            window.open(`${process.env.REACT_APP_API_URL}/download/${item.id}/${orderData.order_id}/${orderData.user_id}/link/${item.media_name ? encodeURIComponent(item.media_name) : "linkproduct"}`, '_blank')
        } else {
            window.open(`${process.env.REACT_APP_API_URL}/download/${item.id}/${orderData.order_id}/${orderData.user_id}/download/${encodeURIComponent(item.media_name)}`, '_blank')
        }
    }

    useEffect(() => {
        console.log("search", search)
        try {
            if (search == "") {
                setfilterProducts(getDownloads())
            } else {
                setfilterProducts(getDownloads().filter(item =>
                    item.product_name?.toLowerCase().includes(search.toLowerCase()) ||
                    item.media_name?.toLowerCase().includes(search.toLowerCase())
                ))
            }
        } catch (error) {
            console.log("error search", error)
        }
    }, [search])

    useEffect(() => {
        document.querySelectorAll('.insert-toolbar-plus').forEach(element => {
            element.parentElement.remove();
        });
        document.body.style.backgroundColor = "#fff"
    }, [])

    return (

        statusLogin !== true ?
            <>
                <LanguageBar />
                <LoginOrder
                    statusLogin={statusLogin}
                    setStatusLogin={setStatusLogin}
                />
            </> :
            products.loading ?
                <div style={{ display: "flex", width: "100%", height: "100vh", alignContent: "center", justifyContent: "center" }}>
                    <Loading />
                </div> :
                products.error == true ?
                    products.data?.status === 503 ?
                        <>
                            <LanguageBar />
                            <PageForbidden status={products.data?.status} />
                        </> :
                        <>
                            <LanguageBar />
                            <PageError
                                status={products.data?.status}
                                onRetry={() => window.location.reload()}
                            />
                        </> :
                products.data?.is_canceled === true ?
                    <PageLock /> :
                    <>
                        <LanguageBar />
                        <TableDownload
                            config={config}
                            filterProducts={filterProducts}
                            getColorMedia={getColorMedia}
                            getColorMediaStyle={getColorMediaStyle}
                            sizeFiles={sizeFiles}
                            getColorType={getColorType}
                            getColorTypeStyle={getColorTypeStyle}
                            getColorButton={getColorButton}
                            getColorButtonStyle={getColorButtonStyle}
                            search={search}
                            setsearch={setsearch}
                            download={download}
                        />
                    </>
    )
}


